import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MAIN_SITE = "https://kaspreadsheet.com";

export default function Hero() {
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20editorial%20still%20life%20of%20folded%20terracotta%20and%20cream%20apparel%20with%20leather%20accessories%20and%20a%20pair%20of%20sneakers%20arranged%20on%20a%20rich%20sage%20green%20surface%20with%20dramatic%20soft%20window%20light%2C%20artistic%20minimal%20composition%20with%20strong%20shadows%20and%20warm%20earth%20tones%2C%20premium%20e-commerce%20lifestyle%20photography&width=1600&height=900&seq=hero-01&orientation=landscape&nocache=true"
          alt="USFans Spreadsheet apparel and product flat lay"
          title="USFans Spreadsheet Products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-3xl mx-auto text-center">
          <p className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 text-background-50 text-xs font-semibold tracking-widest uppercase mb-6">
            <i className="ri-sparkling-2-line"></i>
            {t("hero.eyebrow")}
          </p>
          <h1 className="font-heading text-3xl md:text-5xl font-extrabold text-background-50 leading-tight mb-5">
            {t("hero.title")}
          </h1>
          <p className="text-base md:text-lg text-background-50/90 leading-relaxed mb-8 max-w-2xl mx-auto">
            {t("hero.subtitle")}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={MAIN_SITE}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto h-12 px-7 inline-flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-semibold hover:bg-primary-600 transition whitespace-nowrap"
            >
              {t("hero.ctaSpreadsheet")}
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
            <a
              href={MAIN_SITE}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto h-12 px-7 inline-flex items-center justify-center rounded-md bg-background-50 text-foreground-950 font-semibold hover:bg-background-100 transition whitespace-nowrap"
            >
              {t("hero.ctaBuyNow")}
            </a>
          </div>

          <div className="mt-6">
            <Link
              to={`/${lang}/article/usfans-spreadsheet-guide`}
              className="inline-flex items-center gap-2 text-sm text-background-50/90 hover:text-background-50 underline underline-offset-4 transition"
            >
              {t("hero.ctaBrowse")}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <p className="mt-8 text-xs text-background-50/70">{t("hero.trust")}</p>
        </div>
      </div>
    </section>
  );
}